import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import ImageCollection from "../../../components/ImageCollection";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Flooring choices address more than practicality. They communicate function and atmosphere.`}</p>
    </PageDescription>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Concrete</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Carpet</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Wood</AnchorLink>
    </AnchorLinks>
    <h2>{`Concrete`}</h2>
    <p>{`Concrete speaks to energy and industry and adds a durable, yet progressive, look. The raw, natural characteristics of the material, juxtaposed with more refined details throughout the environment, support the design principle of duality. When using polished concrete isn’t feasible, luxury vinyl tile (LVT) or other hard flooring with a similar appearance may be used. Use a neutral gray tone that complements the visual identity color palette.`}</p>
    <p>{`Existing concrete floors should be lightly sanded and polished to enhance the natural characteristics of the material. Avoid highly polished and glossy finishes.`}</p>
    <p>{`Concrete flooring works well in `}<a parentName="p" {...{
        "href": "/workplace-xg/space-types/welcome"
      }}>{`Welcome`}</a>{`, `}<a parentName="p" {...{
        "href": "/workplace-xg/space-types/connect"
      }}>{`Connect`}</a>{` and `}<a parentName="p" {...{
        "href": "/workplace-xg/space-types/play"
      }}>{`Play`}</a>{` zones, as well as open `}<a parentName="p" {...{
        "href": "/workplace-xg/space-types/collaborate"
      }}>{`Collaborate`}</a>{` zones and major circulation pathways.`}</p>
    <ImageCollection mdxType="ImageCollection">
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMEAv/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHVzKCaGQWsEwv/xAAbEAACAgMBAAAAAAAAAAAAAAACAwERABIhE//aAAgBAQABBQKV3PnRJVYEfbOSVLNQnLxPA//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EAB8QAAEDAwUAAAAAAAAAAAAAAAABAiERMTMQQXGBkf/aAAgBAQAGPwK9ODI4yOSVL0IcvpC769n/xAAaEAEAAwADAAAAAAAAAAAAAAABABEhMUFx/9oACAEBAAE/IQMHIKDHTOkHstx7cS0bF3At1W7iXCi4MVxQ65n/2gAMAwEAAgADAAAAEGcffP/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8QH//EABsQAQEAAwEBAQAAAAAAAAAAAAERACExYYFB/9oACAEBAAE/EIB4tHmKKwOat+48oyjrSLgSaqhv4PMt2QSA+c55iOZrI7W5WLlUo01uACCt623P/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Concrete flooring in hallway",
            "title": "Concrete flooring in hallway",
            "src": "/workplace-xg/static/acbe9c09a7fc5123bc0df03242b8f201/473e3/concrete-flooring-in-hallway.jpg",
            "srcSet": ["/workplace-xg/static/acbe9c09a7fc5123bc0df03242b8f201/69549/concrete-flooring-in-hallway.jpg 288w", "/workplace-xg/static/acbe9c09a7fc5123bc0df03242b8f201/473e3/concrete-flooring-in-hallway.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMFAgT/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB30TKUrRAf//EABoQAAIDAQEAAAAAAAAAAAAAAAECAAMREiP/2gAIAQEAAQUCUsK1Q4I2GCzz7n//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAaEAABBQEAAAAAAAAAAAAAAAABAAIQITGR/9oACAEBAAY/Asb1BxuKQj//xAAbEAACAwADAAAAAAAAAAAAAAAAAREhMVFxgf/aAAgBAQABPyGt3YIcJq14LvZNVkkoiT2EJOGf/9oADAMBAAIAAwAAABD0L//EABYRAQEBAAAAAAAAAAAAAAAAAAEAEf/aAAgBAwEBPxBCy//EABYRAQEBAAAAAAAAAAAAAAAAAAEAEf/aAAgBAgEBPxAW2//EAB4QAQEAAgEFAQAAAAAAAAAAAAERACExUWGBkaGx/9oACAEBAAE/ECoymgn3NA8Q8ClhwfuQA6315y6IgBgB2yV+PRHE1aL1z//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Conrete flooring in high traffic area",
            "title": "Conrete flooring in high traffic area",
            "src": "/workplace-xg/static/fcf7c9ecd5505038d9e32f78917539f6/2e753/conrete-flooring-in-high-traffic-area.jpg",
            "srcSet": ["/workplace-xg/static/fcf7c9ecd5505038d9e32f78917539f6/69549/conrete-flooring-in-high-traffic-area.jpg 288w", "/workplace-xg/static/fcf7c9ecd5505038d9e32f78917539f6/473e3/conrete-flooring-in-high-traffic-area.jpg 576w", "/workplace-xg/static/fcf7c9ecd5505038d9e32f78917539f6/2e753/conrete-flooring-in-high-traffic-area.jpg 1152w", "/workplace-xg/static/fcf7c9ecd5505038d9e32f78917539f6/a052a/conrete-flooring-in-high-traffic-area.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Play zones benefit from the durable practicality of concrete.</Caption>
      </Column>
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAMCBAX/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABi9iYtGUR/8QAGhABAAIDAQAAAAAAAAAAAAAAAgEDAAQRMf/aAAgBAQABBQJa1cEVgHleSDxeGc//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAaEAACAgMAAAAAAAAAAAAAAAAAARBBESEx/9oACAEBAAY/AtPBUXHWf//EABoQAAMBAQEBAAAAAAAAAAAAAAABESExUXH/2gAIAQEAAT8hfG2/dENP6gpY6vRC22JqLCK57yH/2gAMAwEAAgADAAAAEEc//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAGxABAQADAQEBAAAAAAAAAAAAAREAITFBUWH/2gAIAQEAAT8Q1wQREPwuI5Z0Z73eIDS4NjhUOIyz9y6ArpPMFwLWgmf/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Concrete flooring defines walk areas",
            "title": "Concrete flooring defines walk areas",
            "src": "/workplace-xg/static/50a95e1bf8f9548b4a80145de81b5ff6/2e753/concrete-flooring-defines-walk-areas.jpg",
            "srcSet": ["/workplace-xg/static/50a95e1bf8f9548b4a80145de81b5ff6/69549/concrete-flooring-defines-walk-areas.jpg 288w", "/workplace-xg/static/50a95e1bf8f9548b4a80145de81b5ff6/473e3/concrete-flooring-defines-walk-areas.jpg 576w", "/workplace-xg/static/50a95e1bf8f9548b4a80145de81b5ff6/2e753/concrete-flooring-defines-walk-areas.jpg 1152w", "/workplace-xg/static/50a95e1bf8f9548b4a80145de81b5ff6/a052a/concrete-flooring-defines-walk-areas.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Smooth concrete underscores intended traffic flow.</Caption>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIFAwT/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABqGDQxOE6dhlglUP/xAAdEAACAgIDAQAAAAAAAAAAAAABAgADERIEEzMh/9oACAEBAAEFAsCfJqJS5dEs2ay9+zi+SJqbvZRgQqCf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAHhAAAgICAgMAAAAAAAAAAAAAAAERIQLhEBJScYH/2gAIAQEABj8C2bNljXjTGlCg+mTmezkz9lcWj//EABwQAQACAgMBAAAAAAAAAAAAAAEAERBBIVFhgf/aAAgBAQABPyE9ITqy+8PaljVm4JW30hqWVc84iX3YaxAUCoy6As//2gAMAwEAAgADAAAAENs3vv/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8QH//EABYRAAMAAAAAAAAAAAAAAAAAAAAQEf/aAAgBAgEBPxB0/8QAHRABAAICAwEBAAAAAAAAAAAAAQARITFBUWFxwf/aAAgBAQABPxAQNUfRKX6JcyX9Uc01t1PjHEB461KWq7l73qlTXMxely+xSFGnro8lXMGe4XAAwHEbUd9mJc//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Concrete flooring in lobby",
            "title": "Concrete flooring in lobby",
            "src": "/workplace-xg/static/a9fc372b8f469c2260094a95c4c0532d/473e3/concrete-flooring-in-lobby.jpg",
            "srcSet": ["/workplace-xg/static/a9fc372b8f469c2260094a95c4c0532d/69549/concrete-flooring-in-lobby.jpg 288w", "/workplace-xg/static/a9fc372b8f469c2260094a95c4c0532d/473e3/concrete-flooring-in-lobby.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQBAwX/xAAVAQEBAAAAAAAAAAAAAAAAAAABAP/aAAwDAQACEAMQAAAB1kr0IeJB/8QAHRAAAgEEAwAAAAAAAAAAAAAAAQIDAAQREhMiMf/aAAgBAQABBQLNXMhQITofJF5Ao6//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAgEBPwFX/8QAGRABAAIDAAAAAAAAAAAAAAAAAAERITFx/9oACAEBAAY/AkUi2W6Rx//EABgQAQEBAQEAAAAAAAAAAAAAAAERACEx/9oACAEBAAE/IfPcry1nc5fSXOV407qHAHbAb//aAAwDAQACAAMAAAAQt/8A/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAER/9oACAEDAQE/EGV//8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQIBAT8QQ//EABoQAQEAAwEBAAAAAAAAAAAAAAERACExQWH/2gAIAQEAAT8QSKafMO9kovJfMRrTU5suErJwTrkggsewmakgDOgZ/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "contemporary concrete wall",
            "title": "contemporary concrete wall",
            "src": "/workplace-xg/static/63945f4cd0202a136dbf4337fee87291/2e753/contemporary-concrete-wall.jpg",
            "srcSet": ["/workplace-xg/static/63945f4cd0202a136dbf4337fee87291/69549/contemporary-concrete-wall.jpg 288w", "/workplace-xg/static/63945f4cd0202a136dbf4337fee87291/473e3/contemporary-concrete-wall.jpg 576w", "/workplace-xg/static/63945f4cd0202a136dbf4337fee87291/2e753/contemporary-concrete-wall.jpg 1152w", "/workplace-xg/static/63945f4cd0202a136dbf4337fee87291/a052a/contemporary-concrete-wall.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Concrete plays a supporting role to the contemporary wall finishes in this hallway.</Caption>
      </Column>
    </ImageCollection>
    <h2>{`Carpet`}</h2>
    <p>{`A variety of carpet tiles within the environment help delineate zones and circulation paths. The style should look refined and elegant.`}</p>
    <p>{`Choose a neutral palette of grays, ranging from dark to medium. Choose a small-scale pattern, remembering to keep to 3 or fewer patterns within a space. Subtle linear and grid-like patterns can be used to create more movement when needed.`}</p>
    <p>{`Carpet works well in open offices, interior enclosed meeting rooms and lounges, and phone and focus rooms. Generally, the open workplace zone receives a different carpet tile than the enclosed rooms. All carpet tile should be specified from the current IBM-approved flooring supplier list. Any deviation from this list must be approved by IBM Global Real Estate.`}</p>
    <p>{`Use colorful and patterned area rugs on top of carpeted areas to help delineate specific spaces.`}</p>
    <ImageCollection mdxType="ImageCollection">
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAwAC/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAUxGNBS//8QAGBABAQADAAAAAAAAAAAAAAAAAgEAAxH/2gAIAQEAAQUCux9DVe22JjJOOiZ//8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQMBAT8BJ//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/AWf/xAAXEAEBAQEAAAAAAAAAAAAAAAAAATEh/9oACAEBAAY/AtSWtbXXK//EABsQAAICAwEAAAAAAAAAAAAAAAABESExQVFx/9oACAEBAAE/IXmpnhQw8IXDG0XtJ0j4GoShMhds/9oADAMBAAIAAwAAABCUz//EABYRAQEBAAAAAAAAAAAAAAAAAAARAf/aAAgBAwEBPxDFR//EABYRAQEBAAAAAAAAAAAAAAAAAAARAf/aAAgBAgEBPxDUV//EABoQAQEBAQEBAQAAAAAAAAAAAAERIQAxUYH/2gAIAQEAAT8QIJaDHXJNiA6RAQ6dvc0MBG8aEy1KLkz50RpQ9vb7+9//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Flooring in informal seating area",
            "title": "Flooring in informal seating area",
            "src": "/workplace-xg/static/0eed011be4b853708f37c56133dc69de/2e753/flooring-in-informal-seating-area.jpg",
            "srcSet": ["/workplace-xg/static/0eed011be4b853708f37c56133dc69de/69549/flooring-in-informal-seating-area.jpg 288w", "/workplace-xg/static/0eed011be4b853708f37c56133dc69de/473e3/flooring-in-informal-seating-area.jpg 576w", "/workplace-xg/static/0eed011be4b853708f37c56133dc69de/2e753/flooring-in-informal-seating-area.jpg 1152w", "/workplace-xg/static/0eed011be4b853708f37c56133dc69de/a052a/flooring-in-informal-seating-area.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Carpet creates a place to step away from the flow into an informal seating
  area.
        </Caption>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAMCBAUB/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQID/9oADAMBAAIQAxAAAAGdDSyUUcLjaquRnokkJ//EAB0QAAICAQUAAAAAAAAAAAAAAAECAAMhERIiIzL/2gAIAQEAAQUCLYsPONUwlvtgVLZm3tNLMdY2Wn//xAAXEQADAQAAAAAAAAAAAAAAAAAAAhAR/9oACAEDAQE/AWMv/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAEQEf/aAAgBAgEBPwFXT//EAB4QAAEEAQUAAAAAAAAAAAAAAAABEBExgRIhMlFx/9oACAEBAAY/AqMNUmCFs2U46oJ7ZfEb/8QAHRABAAICAgMAAAAAAAAAAAAAAQARIVExQWGRof/aAAgBAQABPyHUT5EWWRg2R9NIh4XMCnCalCzYBKj3HK4q0h7PgagUcvuf/9oADAMBAAIAAwAAABCrPQ7/xAAXEQEBAQEAAAAAAAAAAAAAAAABABAR/9oACAEDAQE/EEomG4X/xAAXEQEBAQEAAAAAAAAAAAAAAAAAAREh/9oACAECAQE/EObGpWn/xAAfEAACAwACAgMAAAAAAAAAAAABEQAhMUFRYXGRsdH/2gAIAQEAAT8QtjUbcdkBC+5ZA1UHinCJ0fMA0sALR6l8IExjtI4RreMgv1JQk7MCXoQbBBaHbqDQE+/7P//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "carpet in conference area",
            "title": "carpet in conference area",
            "src": "/workplace-xg/static/3adcaa0a815dc9b826d3e6e440da8dee/473e3/carpet-in-conference-area.jpg",
            "srcSet": ["/workplace-xg/static/3adcaa0a815dc9b826d3e6e440da8dee/69549/carpet-in-conference-area.jpg 288w", "/workplace-xg/static/3adcaa0a815dc9b826d3e6e440da8dee/473e3/carpet-in-conference-area.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAUBAgME/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQAC/9oADAMBAAIQAxAAAAGa7cZNRSZf/8QAGhABAAIDAQAAAAAAAAAAAAAAAQACAxEhEv/aAAgBAQABBQIOLqvlgcyVYZrB/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQIBAT8BZ//EABwQAAEDBQAAAAAAAAAAAAAAAAABECERMUFxof/aAAgBAQAGPwIwX40E0XZ//8QAGxAAAwACAwAAAAAAAAAAAAAAAAERITFBYXH/2gAIAQEAAT8hZWsDe80W4BDa3Ig40aJBPIf/2gAMAwEAAgADAAAAEDzv/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAR/9oACAEDAQE/EMS1v//EABYRAQEBAAAAAAAAAAAAAAAAAAEAEf/aAAgBAgEBPxBC2F//xAAaEAEAAwEBAQAAAAAAAAAAAAABABEhMZFR/9oACAEBAAE/ED4iqms4xtrG7sgcfGLgdb2bEKq+7L9YXbX0Sf/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "meeting room carpet",
            "title": "meeting room carpet",
            "src": "/workplace-xg/static/6e4e5ce52f3165fad18a958edf08afa9/968f2/meeting-room-carpet.jpg",
            "srcSet": ["/workplace-xg/static/6e4e5ce52f3165fad18a958edf08afa9/69549/meeting-room-carpet.jpg 288w", "/workplace-xg/static/6e4e5ce52f3165fad18a958edf08afa9/473e3/meeting-room-carpet.jpg 576w", "/workplace-xg/static/6e4e5ce52f3165fad18a958edf08afa9/968f2/meeting-room-carpet.jpg 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "896px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAgMA/8QAFAEBAAAAAAAAAAAAAAAAAAAAAv/aAAwDAQACEAMQAAABLogoa+K//8QAGBAAAwEBAAAAAAAAAAAAAAAAAAECEiL/2gAIAQEAAQUCUMUGSuVFDij/xAAWEQEBAQAAAAAAAAAAAAAAAAAAEgH/2gAIAQMBAT8BrVP/xAAXEQEAAwAAAAAAAAAAAAAAAAAAARES/9oACAECAQE/Acwp/8QAGhABAAEFAAAAAAAAAAAAAAAAADEBAhAhQf/aAAgBAQAGPwLiaJWt4//EABoQAAIDAQEAAAAAAAAAAAAAAAERACExQYH/2gAIAQEAAT8hRRa1uwnQU9hXiKJrswBNNoQjH4Z//9oADAMBAAIAAwAAABD3L//EABcRAAMBAAAAAAAAAAAAAAAAAAABESH/2gAIAQMBAT8QSMKP/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAER/9oACAECAQE/ELRl/8QAGxABAQADAAMAAAAAAAAAAAAAAREAITFRYYH/2gAIAQEAAT8QMUTQztOG+4obRS8FmK51KS796yrtPZfnMbngjsmJEACQQz//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "carpet in open work zone",
            "title": "carpet in open work zone",
            "src": "/workplace-xg/static/0abb948dab7396c6b98f5f4fb6573508/968f2/carpet-in-open-work-zone.jpg",
            "srcSet": ["/workplace-xg/static/0abb948dab7396c6b98f5f4fb6573508/69549/carpet-in-open-work-zone.jpg 288w", "/workplace-xg/static/0abb948dab7396c6b98f5f4fb6573508/473e3/carpet-in-open-work-zone.jpg 576w", "/workplace-xg/static/0abb948dab7396c6b98f5f4fb6573508/968f2/carpet-in-open-work-zone.jpg 896w"],
            "sizes": "(max-width: 896px) 100vw, 896px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAQFAQP/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABZyT0KQgR/8QAGhABAQACAwAAAAAAAAAAAAAAAQACERITIf/aAAgBAQABBQLniHYNrKfENzf/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAdEAACAQQDAAAAAAAAAAAAAAAAASECEBGRMWGB/9oACAEBAAY/AoZjKfpxTshJrsnVv//EAB0QAAICAQUAAAAAAAAAAAAAAAABESExQVFhcYH/2gAIAQEAAT8hsoF2YLQbBMUr1DtU4yrWOg2jhSGs/9oADAMBAAIAAwAAABBTP//EABcRAQADAAAAAAAAAAAAAAAAAAABEVH/2gAIAQMBAT8QXGP/xAAWEQEBAQAAAAAAAAAAAAAAAAAAARH/2gAIAQIBAT8QZX//xAAdEAEAAgICAwAAAAAAAAAAAAABABEhMUFRcYGx/9oACAEBAAE/EHq5Nhr1FTbUwHxi4AyHIX1CVgwfBuErgbN53iXbaK0T/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "carpet in open work desk area",
            "title": "carpet in open work desk area",
            "src": "/workplace-xg/static/900b4880da61a50d3f631f38288e6d58/2e753/carpet-in-open-work-desk-area.jpg",
            "srcSet": ["/workplace-xg/static/900b4880da61a50d3f631f38288e6d58/69549/carpet-in-open-work-desk-area.jpg 288w", "/workplace-xg/static/900b4880da61a50d3f631f38288e6d58/473e3/carpet-in-open-work-desk-area.jpg 576w", "/workplace-xg/static/900b4880da61a50d3f631f38288e6d58/2e753/carpet-in-open-work-desk-area.jpg 1152w", "/workplace-xg/static/900b4880da61a50d3f631f38288e6d58/a052a/carpet-in-open-work-desk-area.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Open work zones use carpet to underscore the quiet focus expected in the area. </Caption>
      </Column>
    </ImageCollection>
    <h2>{`Wood`}</h2>
    <p>{`While concrete or luxury vinyl tile capably serve the practical needs of high-traffic areas, the aesthetic of hard surface floors can seem austere in smaller interiors. Where hard surface flooring speaks to energy and industry, the warmth of wood floors speaks a quieter, more subdued language. For `}<a parentName="p" {...{
        "href": "/workplace-xg/space-types/welcome"
      }}>{`Welcome`}</a>{` zones, particularly in historical buildings, wood recalls the original industry of the structure. For `}<a parentName="p" {...{
        "href": "/workplace-xg/space-types/collaborate"
      }}>{`Collaborate`}</a>{` zones, it brings a refined, almost academic feel to spaces where detailed engagement occurs.`}</p>
    <p>{`A natural finish on white oak or other minimally figured wood highlights the intrinsic authenticity of wood, complementing and enhancing the gray tones of the IBM palette and our brand colors.`}</p>
    <ImageCollection mdxType="ImageCollection">
      <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABAABA//EABUBAQEAAAAAAAAAAAAAAAAAAAAC/9oADAMBAAIQAxAAAAEXZORRZsf/xAAbEAACAgMBAAAAAAAAAAAAAAAAAgERAxASE//aAAgBAQABBQKOmfyzE2hRWv/EABYRAQEBAAAAAAAAAAAAAAAAAAAREv/aAAgBAwEBPwHKP//EABURAQEAAAAAAAAAAAAAAAAAAAAS/9oACAECAQE/AaU//8QAGRABAAIDAAAAAAAAAAAAAAAAEQACIHHh/9oACAEBAAY/AirOwsu8P//EABwQAAICAgMAAAAAAAAAAAAAAAERACEQkUFhgf/aAAgBAQABPyETFrNOsUEeNCPncXvcAAn/2gAMAwEAAgADAAAAEBfv/8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQMBAT8Qo//EABYRAAMAAAAAAAAAAAAAAAAAAAARUf/aAAgBAgEBPxBYJD//xAAdEAEBAAEFAQEAAAAAAAAAAAABEQAhMUFRocHR/9oACAEBAAE/EBgBhQG/O2Khq/GXto1ojqzzLTY6rPV3/cEhZeVc/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Welcome zone",
            "title": "Welcome zone",
            "src": "/workplace-xg/static/059dadef4b495b38bb27431ac43c9549/2e753/welcome-zone.jpg",
            "srcSet": ["/workplace-xg/static/059dadef4b495b38bb27431ac43c9549/69549/welcome-zone.jpg 288w", "/workplace-xg/static/059dadef4b495b38bb27431ac43c9549/473e3/welcome-zone.jpg 576w", "/workplace-xg/static/059dadef4b495b38bb27431ac43c9549/2e753/welcome-zone.jpg 1152w", "/workplace-xg/static/059dadef4b495b38bb27431ac43c9549/74f4b/welcome-zone.jpg 1728w", "/workplace-xg/static/059dadef4b495b38bb27431ac43c9549/f35b7/welcome-zone.jpg 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Welcome zones with wood floors present a warm invitation to visitors.
        </Caption>
      </Column>
      <Column colLg={4} colMd={3} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "133.33333333333331%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAbABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIEAwX/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAaMsUl6hKIknSfG5zYP/xAAdEAACAQQDAAAAAAAAAAAAAAABAhIAAxETBBQg/9oACAEBAAEFAttuuxbyHBDASYY5DIkiGNENtgfH/8QAFhEBAQEAAAAAAAAAAAAAAAAAABEQ/9oACAEDAQE/AciP/8QAFhEBAQEAAAAAAAAAAAAAAAAAABEQ/9oACAECAQE/Acqv/8QAHxAAAgIBBAMAAAAAAAAAAAAAAAECIUEQESAiMXGh/9oACAEBAAY/ArkkZ9lSRLqhUsFw+D2088P/xAAdEAEAAgICAwAAAAAAAAAAAAABABEhMUFhUXGx/9oACAEBAAE/IcF/QjhljpLkk9wDWPcQmTgSw2niLQDMYbG8ZqChbmqnM3P/2gAMAwEAAgADAAAAEOA1cv/EABYRAQEBAAAAAAAAAAAAAAAAAAABEf/aAAgBAwEBPxCtWGH/xAAXEQEBAQEAAAAAAAAAAAAAAAABABAR/9oACAECAQE/EBwV1f/EAB8QAQADAAEEAwAAAAAAAAAAAAEAESExQVFxoYGR0f/aAAgBAQABPxAShOzZ9IID1ywfHMGvXDU9QkoDousJS4AgsbO0pIqUuL7hjRDjzpDq4MFmSkkh0fyHIZFteLgAtNn/2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "wood flooring",
            "title": "wood flooring",
            "src": "/workplace-xg/static/1cb316434b101a2b12910984b692c0ee/473e3/wood-flooring.jpg",
            "srcSet": ["/workplace-xg/static/1cb316434b101a2b12910984b692c0ee/69549/wood-flooring.jpg 288w", "/workplace-xg/static/1cb316434b101a2b12910984b692c0ee/473e3/wood-flooring.jpg 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
      <Column colLg={8} colMd={5} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "75%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQDBf/EABUBAQEAAAAAAAAAAAAAAAAAAAEA/9oADAMBAAIQAxAAAAGjbnURWE//xAAYEAADAQEAAAAAAAAAAAAAAAABAiEAA//aAAgBAQABBQIBtcJn6kGIEq//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAaEAADAQADAAAAAAAAAAAAAAAAAREhAhBB/9oACAEBAAY/AphsXWeD510R/8QAGhAAAgMBAQAAAAAAAAAAAAAAAAERITFBUf/aAAgBAQABPyFRqUniKIHCEUF4kamRqy22j//aAAwDAQACAAMAAAAQfD//xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAwEBPxBJ/8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQIBAT8QGf/EABwQAQEAAgIDAAAAAAAAAAAAAAERADEhQVFx8f/aAAgBAQABPxBmJRTaH0wAUmpar4zgQxezK0RTwCl3vHDKb5gpsJ6y2WkVe2Z//9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Collaboration zone",
            "title": "Collaboration zone",
            "src": "/workplace-xg/static/b12263f700b3b2afb8c3ba24ed76a308/2e753/collaboration-zone.jpg",
            "srcSet": ["/workplace-xg/static/b12263f700b3b2afb8c3ba24ed76a308/69549/collaboration-zone.jpg 288w", "/workplace-xg/static/b12263f700b3b2afb8c3ba24ed76a308/473e3/collaboration-zone.jpg 576w", "/workplace-xg/static/b12263f700b3b2afb8c3ba24ed76a308/2e753/collaboration-zone.jpg 1152w", "/workplace-xg/static/b12263f700b3b2afb8c3ba24ed76a308/a052a/collaboration-zone.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Collaboration zones gain a confident energy from wood floors.</Caption>
      </Column>
    </ImageCollection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      